const mcafs020NotificationMailInfo = {
    alertTimingRadio: 0,
    mailAddress: '',
    sysVersionNumber: "-1"
}
export { 
    mcafs020NotificationMailInfo
}